export default __webpack_public_path__ + "static/media/speed.22f0b8ae.svg";